import React from 'react';
import { useHelpShortcut } from '../../hooks/useHelpShortcut';

/**
 * Component that listens for help keyboard shortcuts
 * Should be placed inside HelpWidgetProvider
 */
export const HelpShortcutListener: React.FC = () => {
  useHelpShortcut(true);
  return null; // This component doesn't render anything
};

export default HelpShortcutListener;
